import Vue from 'vue'
import Vuex from 'vuex'
import acl from './modules/acl'
import user from './modules/user'
import auth from './modules/auth'
import axios from '../lib/backend/axios'

Vue.use(Vuex,	axios)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
		acl,
    user,
    auth,
  },
  strict: debug,
})
